import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { RootScopeService } from 'src/app/services/root-scope.service';
import { Location } from '@angular/common';
import { CustomerAccountBusinessLogicService } from '../../../services/customer-account-business-logic.service';
import * as Constants from '../../../models/Constants';
import { PeekabooModalComponent } from '../peekaboo-modal/peekaboo-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-domain-details',
  templateUrl: './domain-details.component.html',
  styleUrls: ['./domain-details.component.scss'],
})
export class DomainDetailsComponent implements OnInit {
  @Input('domainData') domainData: any;
  @Input('selectedIndex') selectedIndex: any = 0;
  @Input('domainName') domainName: string = '';
  @Input('errMsg') errMsg: string = 'NA';
  @Input('domainErrMsg') domainErrMsg: string = 'NA';
  iconConfig: any;
 
  loaderType = Constants.LOADER_TYPE.CARD;
 
  topicErrMsg: string = 'NA';
  noDataMsg = Constants.DATA_NOT_AVAIL_UI;
  constructor(
    private cdr: ChangeDetectorRef,
    public rootScope: RootScopeService,
    // private _location: Location, 
    // CCR3-11321 Checkmarx Issue Fix : This service is not used in this component, so it has been commented out.
    public cusAccService: CustomerAccountBusinessLogicService,
    public dialog: MatDialog,
  ) {
    this.iconConfig = {
      iconName: 'link',
      iconType: 'fas',
      iconPlacement: 'right',
    };
  }

  ngOnInit(): void {
    
    /*istanbul ignore next */
    setTimeout(() => {
      this.onAnchorClick(this.selectedIndex);
      console.log(this.selectedIndex);
    }, 800);
  }

  ngOnChanges(prop) {
    let defaultIndex = 0;
    // console.log('Method ngOnChanges called', prop);
    // console.log('Method ngOnChanges called', this.errMsg);
    if (prop?.domainData) this.domainData = prop?.domainData?.currentValue;
    if (prop?.domainName) this.domainName = prop?.domainName?.currentValue;
    if (prop?.selectedIndex?.currentValue) {
      defaultIndex = (prop?.selectedIndex?.currentValue?.index || prop?.selectedIndex?.currentValue);
    } else if (this.selectedIndex) {
      console.log(this.selectedIndex);
      defaultIndex = this.selectedIndex;
    }
    else if (prop.domainData?.currentValue?.index)
      defaultIndex = prop?.domainData?.currentValue?.index;


    if (prop.selectedIndex || prop.domainData?.currentValue?.index) {
      /*istanbul ignore next */
      setTimeout(() => {
        this.onAnchorClick(
          defaultIndex
        );
      }, 800);
    }

    this.cdr?.detectChanges();
  }

  // set scroll top for all  domain sub categories
  onAnchorClick(path, el?: HTMLElement) {
    //  console.log('Method onAnchorClick called', path);
    let x = document?.getElementById(path);

    if (el) {
      el.scrollTo(0, 0);
    }

    if (x) {
      this.domainData.index = path;
      this.currentSection = path;
      // console.log(' this.currentSection = path;', (this.currentSection = path));
    }

    this.rootScope.activeCustTab.subDomainIndex = path;
    this.cusAccService.handleDomainLoaderForClose();
  }

  currentSection = this.selectedIndex;
  onSectionChange(sectionId: string) {
    this.currentSection = sectionId;
  }
  // Below method load the PeekabooModalComponent
  openKcLinks() {
    this.dialog.open(PeekabooModalComponent, {
      panelClass: 'peekaboo-container',
      backdropClass: 'custom-overlay-peekaboo',
    });
  }

  /**
 * 
 * @param groupObj :
 * Sample groupObj :{
        "sequence": 20.1,
        "errorgroup": [
          "Internal error occured while retrieving data from UDP"
        ],
        "subgroups": [],
        "heading": "",
        "stylegroup": "",
        "id": 30043
      }
    Below method check presence of erroGroup field 
    and accordingly display the message
    @author :Pooja Gupta
 * @returns boolean value
 */

  showErrMsgForTopic(groupObj) {
    this.topicErrMsg = 'NA';
    if (groupObj?.hasOwnProperty(Constants.ERRORGROUP_FIELD)) {
      if (
        groupObj?.[Constants.ERRORGROUP_FIELD] == Constants.DATA_NOT_AVAIL_BACKEND
      ) {
        groupObj.topicErrMsg = Constants.DATA_NOT_AVAIL_UI;
      } else {
        groupObj.topicErrMsg = Constants.PART_OF_CARD_DATA_FAILURE_MSG;
      }
      return true;
    } else {
      return false;
    }
  }

  /***
     * Method to add line seperator.
     * @param  :section divider value from json response
     * @author :Amarjeet Kumar
     */
  dividerValue = 'start';
  sectionChange(sectionDivider) {
    if (sectionDivider == this.dividerValue || this.dividerValue == 'start') {
      if (this.dividerValue == 'start') {
        this.dividerValue = sectionDivider;
      }
      return false;
    }
    else {
      this.dividerValue = sectionDivider;
      return true;
    }
  }

  /***
      * Method to reset dividerValue on each tab.
      * @author :Amarjeet Kumar
      */
  resetdivision() {
    this.dividerValue = 'start';
  }



 

  /**
   * Check if the value is equal to 'NA', then update it to a certain value based on specified criteria.
   * For U.S CCR1-3830.
   * @author Bharat Trikha.
   * @param fieldValue 
   * @param methodName 
   */
  checkForNAValues(fieldValue, methodName) {

    if (fieldValue == 'NA') {
      if (methodName == 'DATEFORMAT') {
        fieldValue = Constants.DATE_NOT_FOUND;
      } else {
        fieldValue = Constants.DATA_NOT_ON_FILE;
      }
    }

    return fieldValue;

  }

  /**
   * CCR1-5124
   * @author : Pooja Gupta
   * 
   * "subgroups": [
              {
                "sections": [
                  {
                    "division": "sra_balance_overpayment_section",
                    "sequence": 21.0,
                    "method": "BALANCE_OVERPAYMENT_DATA",
                    "rule": "TABLE-DATA",
                    "id": "SRA_BALANCE_OVERPAYMENT_SUMMARY",
   */
  isRuleTableType(eachSectionObj){
    if(eachSectionObj?.rule == Constants.TABLE_DATA_RULE){
      //  eachSectionObj.subSectionTable.rows = [];
      //  eachSectionObj.errorgroup = 'No data available'
       return true;
    }
    else{
      return false;
    }

  }

}
